<div class="container-fluid mt-3 g-0 pe-3">

    <div class="row justify-content-center my-2">
        <mat-slide-toggle class="col-auto" [checked]="checked" (change)="change($event)" [disabled]="loadingTask.IsLoading">Afficher les terminées</mat-slide-toggle>
        <!-- <mat-slide-toggle class="col-auto" [(ngModel)]="showAppareil" [disabled]="loadingTask.IsLoading">Voir les appareils</mat-slide-toggle> -->
    </div>

    <!-- @if (showAppareil) {
    <div class="row">
        @if (hasAirIntervention()) {

        <div class=" col m-1">
            <button appPreventDoubleClick class="w-100" [color]="hasBiocollecteur() ? 'primary':'warn'" mat-raised-button (throttledClick)="addAppareil(ETypeAppareil.Biocollecteur)">
                <mat-icon class="material-symbols-outlined">deskphone</mat-icon>
                Biocollecteur
            </button>
        </div>
        }
        @if (hasSurfaceIntervention()) {
        <div class=" col m-1">
            <button appPreventDoubleClick class="w-100 " [color]="hasApplicateurContact() ? 'primary':'warn'" mat-raised-button (throttledClick)="addAppareil(ETypeAppareil.ApplicateurContact)">
                <mat-icon class="material-symbols-outlined">deskphone</mat-icon>
                Applicateur Contact
            </button>
        </div>
        }
    </div> -->
    <!-- @if (hasQualifIntervention()) {
    <div class="row">
        <div class=" col m-1">
            <button appPreventDoubleClick class="w-100" [color]="hasCompteur() ? 'primary':'warn'" mat-raised-button (throttledClick)="addAppareil(ETypeAppareil.Compteur)">
                <mat-icon class="material-symbols-outlined">deskphone</mat-icon>
                Compteur
            </button>
        </div>
        <div class=" col m-1">
            <button appPreventDoubleClick class="w-100 " [color]="hasMultimetre() ? 'primary':'warn'" mat-raised-button (throttledClick)="addAppareil(ETypeAppareil.Multimetre)">
                <mat-icon class="material-symbols-outlined">deskphone</mat-icon>
                Multimetre
            </button>
        </div>
    </div>
    } 
    } -->

    <div class="row mt-3">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Recherche par intitulé</mat-label>
                <input matInput [(ngModel)]="SearchText" placeholder="Intitulé" (keyup)="search()">
                @if (SearchText) {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()" [disabled]="loadingTask.IsLoading">
                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
                }
            </mat-form-field>
        </div>

    </div>
    @for (z of FilteredIntervention?.ZoneList; track z; let i = $index) {
    <div class="col-12 col-md-4 col-xl-2 m-1 " (click)="navigateToZone(z)">
        <div class="h-100 m-3">
            <div class="row border rounded-1 background-light left-card-border" [style.border-left-color]="getColorByPrelevementType(z)">

                <div class="col ms-1 p-2">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col text-center">
                                    <h3 class="fw-bold"> {{z.ZoneSalle}}</h3>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col-auto fst-italic">
                            Prélèvement à réaliser
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-end">
                            {{z.PrelevementAirList.length}}
                        </div>
                        <div class="ms-3 my-auto col">
                            <mat-icon class="material-symbols-outlined">air</mat-icon>
                        </div>
                        <div class="col text-end">
                            {{z.PrelevementSurfaceList.length}}
                        </div>
                        <div class="ms-3 my-auto col">
                            <mat-icon class="material-symbols-outlined">labs</mat-icon>
                        </div>
                        @if (z.PrelevementQualifSalle) {
                        <div class="col text-end">
                            1
                        </div>
                        <div class="ms-3 my-auto col">
                            <mat-icon class="material-symbols-outlined">meeting_room</mat-icon>
                        </div>
                        }
                    </div>
                    <!-- <span class="row text-start" *ngFor="let prel of z.PrelevementAirList">
      <div class="ms-3 my-auto col-auto">
        <mat-icon class="material-symbols-outlined">air</mat-icon>
      </div>
      <span class="col"> {{prel.Code}} / {{prel.LieuPrelevement}}</span>
    </span>
    <span class="row text-start" *ngFor="let prel of z.PrelevementSurfaceList">
      <div class="ms-3 my-auto col-auto">
        <mat-icon class="material-symbols-outlined">labs</mat-icon>
      </div>
      <span class="col"> {{prel.Code}} / {{prel.LieuPrelevement}}</span>
    </span> -->
                </div>
            </div>
        </div>
    </div>
    }
    @for (app of FilteredIntervention?.GenerateurDialyseList; track app; let i = $index) {
    <div class="col-12 col-md-4 col-xl-2 m-1 " (click)="navigateToAppareil(app)">
        <div class="h-100 m-3">
            <div class="row border rounded-1 background-light left-card-border" [style.border-left-color]="getColorByPrelevementType(app)">

                <div class="col ms-1 p-2">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col text-center">
                                    <h3 class="fw-bold"> {{app.ZoneSalle}}</h3>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col-auto fst-italic">
                            Prélèvement à réaliser
                        </div>
                    </div>

                    <div class="row">
                        <div class="col text-end">
                            {{app.PrelevementGenerateurDialyseList.length}}
                        </div>
                        <div class="ms-3 my-auto col">
                            <mat-icon class="material-symbols-outlined">dishwasher_gen</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @for (endoscope of FilteredIntervention?.EndoscopeList; track endoscope; let i = $index) {
    <div class="col-12 col-md-4 col-xl-2 m-1 " (click)="navigateToEndoscope(endoscope)">
        <div class="h-100 m-3">
            <div class="row border rounded-1 background-light left-card-border" [style.border-left-color]="getColorByPrelevementType(endoscope)">

                <div class="col ms-1 p-2">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col text-center">
                                    <h3 class="fw-bold"> {{endoscope.ZoneSalle}}</h3>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col-auto fst-italic">
                            Prélèvement à réaliser
                        </div>
                    </div>

                    <div class="row">
                        <div class="col text-end">
                            {{endoscope.CanalEndoscopeList.length}}
                        </div>
                        <div class="ms-3 my-auto col">
                            <mat-icon class="material-symbols-outlined">cable</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>